module.exports = __webpack_public_path__ + "static/img/corporate_culture_02.24f08e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/corporate_culture_02.png
// module id = dajd
// module chunks = 0